import { Store } from 'src/store/index';
import { posterProductTypeIds } from 'src/api/productTypes';
import getProductTypeId from './getProductTypeId';

const shouldDisplayUpsellBeforeAddToBasket = (store: Store) => (
  posterProductTypeIds.includes(getProductTypeId(store) || 0)) && !store.upsell.isBeforeAddToBasketUpsellWasShown;

export default shouldDisplayUpsellBeforeAddToBasket;
